import { render, staticRenderFns } from "./AddOrUpdateCommonComplaintsModal.vue?vue&type=template&id=69a7f399&"
import script from "./AddOrUpdateCommonComplaintsModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateCommonComplaintsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateCommonComplaintsModal.vue?vue&type=style&index=0&id=69a7f399&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports